import { LOADING_RESTAURANT, SET_RESTAURANTS_ADMIN } from "../actions/setRestaurants";
import { SET_ACTIVE_RESTAURANT_ADMIN } from "../actions/SetActivePropToRestaurant";


export const restaurants = (state = {}, action) => {
    switch(action.type) {
        case SET_RESTAURANTS_ADMIN: {
            return action.payload;
        }
        case SET_ACTIVE_RESTAURANT_ADMIN: {
            const { id, active, isLoading } = action.payload;
            return { ...state, [id]: { ...state[id], active: active, isLoading: isLoading } };
        }
        default:
            return state;
    }
}

export const isLoadingRestaurants = (state = {}, action) => {
    switch(action.type) {
        case LOADING_RESTAURANT: {
            return action.payload;
        }
        default:
            return state;
    }
}